import * as ko from "knockout";
import * as localisationHelper from "localisationHelper";

import InputsBase from "Content/ts/Shared/Inputs/inputs-base";

// Services
import { ValidationService } from "Content/ts/Shared/Services/Validation/validationService";
import { InputValidationService } from "Content/ts/Shared/Inputs/Service/inputValidationService";

// Components
import "Content/ts/Shared/BootstrapAlerts/AlertValidation/alert-validation";

// Models
import { IInputPhoneParams } from "Content/ts/Shared/Inputs/Phone/IInputPhoneParams";
import { PhoneNumberType } from "Content/ts/Models/Account/Validation/PhoneNumberType";

export const Deps = {
    LocalisationHelper: localisationHelper,
    InputValidationService: InputValidationService
};

export default class InputPhone extends InputsBase {
    additionalCustomMessages: {
        PhoneValidationMessage: string;
    };

    phoneNumberType: PhoneNumberType;
    phoneNumberHelpText: string;

    constructor(params: IInputPhoneParams) {
        super(params);

        this.phoneNumberType = params.PhoneType != null
            ? params.PhoneType
            : PhoneNumberType.Mobile;

        // Initialisation Methods
        this.retrieveAdditionalCustomMessages();
        this.retrievePhoneNumberHelpText();
    }

    private retrieveAdditionalCustomMessages(): void {
        this.additionalCustomMessages = {
            PhoneValidationMessage: Deps.LocalisationHelper.getString("ValidationMessageResources", "DefaultValidPhoneNumberMessage")
        };
    };

    private retrievePhoneNumberHelpText() {
        if (this.phoneNumberType != PhoneNumberType.None) {
            Deps.InputValidationService.GetPhoneNumberFormatHelpText({
                LocationId: null,
                Type: this.phoneNumberType
            }).then((helpText: string) => {
                this.phoneNumberHelpText = helpText;
            }).finally(() => {
                this.additionalValidation();
            });
        }
    };

    private additionalValidation(): void {
        ValidationService.AddValidationRule(this.value, this.validationFields, {
            required: {
                params: true,
                message: this.additionalCustomMessages.PhoneValidationMessage
            }
        });

        ValidationService.AddValidationRule(this.value, this.validationFields, {
            validation: {
                async: true,
                validator: (newVal: string, params: any, callback: Function) => {
                    if (newVal && this.phoneNumberType != PhoneNumberType.None) {
                        Deps.InputValidationService.ValidatePhoneNumber({
                            PhoneNumber: newVal,
                            Type: this.phoneNumberType,
                            LocationId: null
                        }).then((response: boolean) => {
                            callback(response);
                            if (!response) {
                                this.value.isModified(true);
                            }
                        });
                    }
                    else { return true; }
                },
                message: this.phoneNumberHelpText
            }
        });
    };

    private removeAdditionalValidation() {
        ValidationService.RemoveValidationRule(this.value, this.validationFields);
        ValidationService.RemoveValidationRule(this.value, this.validationFields);
    };

    public dispose() {
        this.removeAdditionalValidation();
        super.dispose();
    };
}

const componentName = "input-phone";
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: InputPhone,
    template: { require: `text!Content/ts/Shared/Inputs/Phone/${componentName}.html` }
});